module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av315-84389b6cb1433492717de62d9c665e5d.jpg";